import type { ReactNode } from "react";
import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { ChatPanel } from "./ChatPanel";
import "./AppShell.css";

export function AppShell({
  children,
  sidebarCollapsed,
  chatOpen,
  onToggleChat,
}: {
  children: ReactNode;
  sidebarCollapsed?: boolean;
  chatOpen?: boolean;
  onToggleChat?: () => void;
}) {
  const [localChatOpen, setLocalChatOpen] = useState(false);
  const effectiveChatOpen = chatOpen ?? localChatOpen;
  const effectiveToggleChat = onToggleChat ?? (() => setLocalChatOpen((open) => !open));

  return (
    <div className="app">
      <Sidebar collapsed={sidebarCollapsed ?? effectiveChatOpen} />
      <main className="app__main">{children}</main>
      <ChatPanel open={effectiveChatOpen} onToggle={effectiveToggleChat} />
    </div>
  );
}
